import React, {useState, useEffect} from 'react';
import moment from 'moment';
import dashboardActions from '../../../actions/dashboard.actions';
import useStyles from './SupportersSection.styles';
import {getLocale} from 'epic-common/src/locale';
import {formatDateByLocale} from '../../../utils/Utils';
import {useDispatch, useSelector} from 'react-redux';
import {selectEarnedProducts, selectAccountId, selectStoreBaseUrl} from '../../../selectors';
import {getMessage} from '../../../components/common/Message';
import {SupporterChart, SupporterGames, Toolbar, SupporterDatePicker} from '../components';

const CODES = {
    title: 'epic.affiliate.earnings.my_supporters.title.v2'
};

export interface SupportersChartProps {
    className?: string;
    startDate: number | string | Date;
    messages: Record<string, string>;
    enableLink?: boolean;
    isRendering?: boolean;
}

const SupportersChart: React.FC<SupportersChartProps> = ({
    className,
    startDate,
    messages,
    enableLink,
    ...props
}) => {
    const styles = useStyles();
    const dispatch = useDispatch();
    const products = useSelector(selectEarnedProducts);
    const accountId = useSelector(selectAccountId);
    const baseStoreUrl = useSelector(selectStoreBaseUrl);
    const [selectedProductId, setSelectedProductId] = useState('fortnite');
    const [selectedDate, setDate] = useState(moment());
    const {lastFetch, data: earnedProducts} = products || {};
    const selectedItem = earnedProducts[selectedProductId];
    const isRendering = props.isRendering || !lastFetch;

    useEffect(() => {
        dispatch(
            dashboardActions.getEarnedProducts({
                date: formatDateByLocale(selectedDate, 'en-US', 'YYYY-MM'),
                locale: getLocale(),
                version: 2
            })
        );
    }, [selectedDate]);

    const formatMinDate = () => {
        try {
            return moment(startDate)
                .startOf('month')
                .toISOString();
        } catch (err) {
            return startDate;
        }
    };

    return (
        <div className={className}>
            <Toolbar isRendering={isRendering} title={getMessage(messages, CODES.title)}>
                <SupporterGames
                    label={getMessage(messages, 'epic.affiliate.earnings.show_me.v2')}
                    products={products}
                    selectedProductId={selectedProductId}
                    onChange={productId => setSelectedProductId(String(productId))}
                />

                <SupporterDatePicker
                    minDate={formatMinDate()}
                    maxDate={new Date()}
                    onChange={setDate}
                />
            </Toolbar>

            <div className={styles.listWrapper}>
                <SupporterChart
                    isRendering={isRendering}
                    date={selectedDate}
                    item={selectedItem}
                    enableLink={enableLink}
                    accountId={accountId}
                    baseStoreUrl={baseStoreUrl}
                />
            </div>
        </div>
    );
};

export default SupportersChart;
